import { render } from "./BugReport.vue?vue&type=template&id=36cb1997&scoped=true"
import script from "./BugReport.vue?vue&type=script&lang=js"
export * from "./BugReport.vue?vue&type=script&lang=js"

import "./BugReport.vue?vue&type=style&index=0&id=36cb1997&scoped=true&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cb1997"]])

export default __exports__